import { render, staticRenderFns } from "./productSaleInfo.vue?vue&type=template&id=5255740c&scoped=true&"
import script from "./productSaleInfo.vue?vue&type=script&lang=js&"
export * from "./productSaleInfo.vue?vue&type=script&lang=js&"
import style0 from "./productSaleInfo.vue?vue&type=style&index=0&id=5255740c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5255740c",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/alibaba/product/components/productSaleInfo.vue
// module id = null
// module chunks = 